import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthGuard } from './auth-guard.service';
import { MsalGuard } from "@azure/msal-angular";

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
    canLoad: [MsalGuard]
  },
  {
    path: 'absence',
    loadChildren: () => import('./modules/absence/absence.module').then(m => m.AbsenceModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'article',
    loadChildren: () => import('./modules/article/article.module').then(m => m.ArticleModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'container',
    loadChildren: () => import('./modules/container/container.module').then(m => m.ContainerModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'container-planning',
    loadChildren: () => import('./modules/container-planning/container-planning.module').then(m => m.ContainerPlanningModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'custom1',
    loadChildren: () => import('./modules/custom1/custom1.module').then(m => m.Custom1Module),
    canLoad: [AuthGuard]
  },
  {
    path: 'customer',
    loadChildren: () => import('./modules/customer/customer.module').then(m => m.CustomerModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'deviation',
    loadChildren: () => import('./modules/deviation/deviation.module').then(m => m.DeviationModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'employee',
    loadChildren: () => import('./modules/employee/employee.module').then(m => m.EmployeeModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'form',
    loadChildren: () => import('./modules/form/form.module').then(m => m.FormModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'home',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'invoice',
    loadChildren: () => import('./modules/invoice/invoice.module').then(m => m.InvoiceModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'message',
    loadChildren: () => import('./modules/message/message.module').then(m => m.MessageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'monitor',
    loadChildren: () => import('./modules/monitor/monitor.module').then(m => m.MonitorModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'performance',
    loadChildren: () => import('./modules/performance/performance.module').then(m => m.PerformanceModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'personnel',
    loadChildren: () => import('./modules/personnel/personnel.module').then(m => m.PersonnelModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'planning',
    loadChildren: () => import('./modules/planning/planning.module').then(m => m.PlanningModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'project',
    loadChildren: () => import('./modules/project/project.module').then(m => m.ProjectModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'report',
    loadChildren: () => import('./modules/report/report.module').then(m => m.ReportModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'salary',
    loadChildren: () => import('./modules/salary/salary.module').then(m => m.SalaryModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'time',
    loadChildren: () => import('./modules/time/time.module').then(m => m.TimeModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'basic',
    loadChildren: () => import('./modules/basic/basic.module').then(m => m.BasicModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'wms',
    loadChildren: () => import('./modules/wms/wms.module').then(m => m.WmsModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'tracking',
    loadChildren: () => import('./modules/tracking/tracking.module').then(m => m.TrackingModule),
    canLoad: [AuthGuard]
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'purchase',
    loadChildren: () => import('./modules/purchase/purchase.module').then(m => m.PurchaseModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'external-viewer',
    loadChildren: () => import('./modules/external-viewer/external-viewer.module').then(m => m.ExternalViewerModule),
    canLoad: [AuthGuard]
  },
   {
     path: 'log',
     loadChildren: () => import('./modules/log/log.module').then(m => m.LogModule),
     canLoad: [AuthGuard]
   },
   {
     path: 'price-handling',
     loadChildren: () => import('./modules/price-handling/price-handling.module').then(m => m.PriceHandlingModule),
     canLoad: [AuthGuard]
   },
   {
     path: 'oee',
     loadChildren: () => import('./modules/oee/oee.module').then(m => m.OeeModule),
     canLoad: [AuthGuard]
   },
   {
     path: 'production',
     loadChildren: () => import('./modules/production/production.module').then(m => m.ProductionModule),
     canLoad: [AuthGuard]
   },
   {
     path: 'production-status',
     loadChildren: () => import('./modules/production-status/production-status.module').then(m => m.ProductionStatusModule),
     canLoad: [AuthGuard]
   },
   {
     path: 'interface',
     loadChildren: () => import('./modules/interface/interface.module').then(m => m.InterfaceModule),
     canLoad: [AuthGuard]
   },
  {
    path: 'document',
    loadChildren: () => import('./modules/document/document.module').then(m => m.DocumentModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'billing',
    loadChildren: () => import('./modules/billing/billing.module').then(m => m.BillingModule),
    canLoad: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }
